import { Scheduling } from "../../models/schedule";

interface ICard {
    setShowDialog: (showDialog: boolean) => void;
    chooseScheduling: () => void;
    scheduling: Scheduling;
}

const Card = ({ setShowDialog, scheduling, chooseScheduling }: ICard) => {
    return (
        <div
            className="alert alert-dismissible alert-info cursor-pointer my-10 dark:bg-[#2a2a2a] dark:border-[#31b5c0]"
            onClick={() => {
                chooseScheduling();
                setShowDialog(true);
            }}
        >
            <div className="display-flex gap-10">
                <div className="w-full">
                    <div className="alert-header flex justify-between dark:text-white">
                        <strong className="dark:text-white">Revisão {scheduling.checkup?.description}</strong>
                        <strong className="dark:text-[#31b5c0]">
                            {new Date(scheduling.date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                        </strong>
                    </div>
                    <div className="margin-y-5 flex flex-column dark:text-white">
                        <div className="dark:text-white">{scheduling.asset?.name}</div>
                        <div className="dark:text-white">Chassi: {scheduling.asset?.chassis}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card;